import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions';

const defaultState = {
  current: {},
  sets: [],
  take: 50,
  page: 1,
  count: 0,
  query: { uploadDatetime: 'Any', photoSetName: '', missingCredits: 'All', onlyPhoto: 'All', addedById: null },
  userOptions: [],
};

const reducer = handleActions(
  {
    [combineActions(actions.photoSets.getPhotoSetsSuccess, actions.photoSets.searchPhotoSetsSuccess)]: (state, { payload: { sets } }) => {
      return { ...state, sets };
    },
    [actions.photoSets.setPhotoSetCount]: (state, { payload: { count } }) => {
      return { ...state, count };
    },
    [actions.photoSets.setPhotoSetPage]: (state, { payload: { page } }) => {
      return { ...state, page };
    },
    [actions.photoSets.setPhotoSetQuery]: (state, { payload: { query } }) => {
      return { ...state, query };
    },
    [combineActions(actions.photoSets.getPhotoSetByIdSuccess)]: (state, { payload: { current } }) => {
      return { ...state, current };
    },
  },
  defaultState
);

export default reducer;
